import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { MainTitle } from 'components/MainTitle';
import { Layout } from 'features/Layouts/Layouts';
import { FC } from 'react';
import { UncreditedPaymentsList } from 'components/UncreditedPaymentsList';
import styles from './UncreditedPaymentsContent.module.scss';
import { useGetUncreditedPaymentsQuery } from 'redux/Api/uncreditedPaymentsApi/uncreditedPaymentsApi';

export const UncreditedPaymentsContent: FC = () => {
  const { data, isLoading } = useGetUncreditedPaymentsQuery();

  return (
    <Layout>
      <div className={styles.root}>
        <MainTitle title='Не зачисленные платежи' count={data?.count} />
        {isLoading ? <LoadingSkeleton /> : <UncreditedPaymentsList data={data?.items} />}
      </div>
    </Layout>
  );
};
